// File Metadata:
// Filename: medicalApiSlice.js
// Version: 1.00
// Created: 2025-03-28 23:11:47
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { apiSlice } from '../../app/api/apiSlice'

export const medicalApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getMedicalStatus: builder.query({
            query: (userId) => `/medical/status/${userId}`,
            providesTags: (result, error, userId) => [{ type: 'Medical', id: userId }]
        }),

        scheduleCheckup: builder.mutation({
            query: ({ userId, ...data }) => ({
                url: '/medical/schedule',
                method: 'POST',
                body: { userId, ...data }
            }),
            invalidatesTags: (result, error, { userId }) => [
                { type: 'Medical', id: userId }
            ]
        }),

        updateCheckupResults: builder.mutation({
            query: ({ checkupId, ...data }) => ({
                url: `/medical/checkup/${checkupId}`,
                method: 'PATCH',
                body: data
            }),
            invalidatesTags: (result, error, { userId }) => [
                { type: 'Medical', id: userId }
            ]
        })
    })
})

export const {
    useGetMedicalStatusQuery,
    useScheduleCheckupMutation,
    useUpdateCheckupResultsMutation
} = medicalApiSlice
